module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Aesch_BL-6e76463d572710b13fff57260a1acfd4.svg";